import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    messages: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {
    messageList: state =>
      state.messages.map(item => ({
        ...item
      }))
  },
  mutations: {
    setMessageTemplates(state, payload) {
      state.messages = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getMessageTemplates({ commit }, query) {
      api.getMessageTemplates(query).then(({ data }) => {
        commit('setMessageTemplates', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    createMessageTemplate(context, data) {
      return api.createMessageTemplate(data);
    },
    updateMessageTemplate(context, data) {
      return api.updateMessageTemplate(data);
    },
    sendMessage(context, data) {
      return api.sendMessage(data);
    }
  }
};

appStore.registerModule('messageTemplate', store);
